import { CancelDowngradeScheduleWrapper } from "../CancelDowngradeScheduleWrapper";
import type { CancelScheduledDowngradeModalSource } from "../types";
import { CANCEL_SCHEDULED_DOWNGRADE_SOURCES } from "../types";
import { useUpgradeFlowShellContext } from "../UpgradeFlowContext";
import { useUpgradePlanContext } from "../UpgradePlanContext";

export const CancelScheduledDowngradeRoute = () => {
  const { modal } = useUpgradeFlowShellContext();
  const { source } = useUpgradePlanContext();

  return (
    <CancelDowngradeScheduleWrapper
      hideModal={modal.hide}
      source={
        (source ||
          CANCEL_SCHEDULED_DOWNGRADE_SOURCES.PLAN_DETAILS) as CancelScheduledDowngradeModalSource
      }
    />
  );
};
